var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"filter-list"}},[_c('h4',[_vm._v(_vm._s(_vm.$t('filter-title')))]),_vm._v(" "),_vm._l((_vm.activeFilters),function(filter){return _c(filter,{key:filter,ref:filter,refInFor:true,tag:"component"})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f0ec419","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/filter/FilterList.vue
// module id = 131
// module chunks = 0